import { useMediaQuery as useMuiMediaQuery } from "@mui/material";

export const useMediaQuery = useMuiMediaQuery;
